import { LayoutBreakpoints, LayoutElement } from "@entaconsulting/form";
import getElementSize from "./getElementSize";

const getRowPositions = (
  elements: LayoutElement[],
  insertAt: number,
  activeBreakpoint: NonNullable<LayoutBreakpoints>
) => {
  if (!elements.length) return { rowStart: 0, rowEnd: -1 };

  let rowStart = 0;
  let rowEnd = -1;
  let i = 0;
  let accumulator = 0;

  do {
    accumulator += getElementSize(elements[i], activeBreakpoint);

    if (accumulator > 12) {
      if (i <= insertAt) {
        accumulator = getElementSize(elements[i], activeBreakpoint);
        rowStart = i;
      } else {
        rowEnd = i - 1;
      }
    }

    i++;
  } while (rowEnd === -1 && elements.length >= i);

  return { rowStart, rowEnd };
};

export default getRowPositions;
